"use client";

import React from "react";
import { useSelector } from "react-redux";

import QuestionLayout from "@/app/layout/question";
import { useWizard } from "@/app/shared-providers/wizard-context-provider";
import { RootState } from "@/store/root-reducer";

import ContactDetailsSupportContent from "./components/description-section";
import ContactdetilasFormSection from "./components/form-section";
import { useContactDetailsContext } from "./provider/contact-details.provider";
import { formCmsData } from "./utils/contact-details-page.util";

function ContactDetails() {
  const { handlers, validations, flags, setters, cmsData } =
    useContactDetailsContext();
  const quoteResponse = useSelector((state: RootState) => state.quote);
  const { loading } = quoteResponse;

  const {
    handleContinue,
    handleBack,
    handleUnSavedWarningMessageContinueBtn,
    isHideFooterBack,
  } = handlers;
  const { setIsOpenUnsavedChangesModal } = setters;
  const { ctaLabelFive, backToRenewalsText } = formCmsData(cmsData);
  const { isCtaActiveWhenTyping, isEmpty, isTyping } = validations;
  const { isOpenUnsavedChangesModal, isLoading } = flags;
  const { current } = useWizard();

  return (
    <QuestionLayout
      footer={{
        isHideFooterBack,
        isLoading: loading || isLoading,
        isDisabledBack: false,
        isDisabledContinue: isTyping ? !isCtaActiveWhenTyping : isEmpty,
        footerActionBack: handleBack,
        footerActionContinue: handleContinue,
        id: "contact-details-footer",
        ctaButtonText: ctaLabelFive,
      }}
      formSection={<ContactdetilasFormSection />}
      descriptionContent={<ContactDetailsSupportContent />}
      progressBarPercent={current.progressBarPercentage ?? 90}
      backToRenewalSection={{
        isOpenUnsavedChangesModal,
        backToRenewalText: backToRenewalsText ?? "Back to Renewal",
        onContinueClick: handleUnSavedWarningMessageContinueBtn,
        setIsOpenUnsavedChangesModal,
      }}
    />
  );
}

export default ContactDetails;
